const INTEGRATION_PDF_PATH =
  /\/project\/integrationModuleWithTab\/[0-9a-f-]{36}\/pdf\/([0-9a-f-]{36})/i;

/**
 * Strip host/protocol so getPdf receives an API path starting with /project/...
 * Handles relative paths, https-prefixed paths, and full gateway URLs.
 */
function stripIntegrationPdfUrlToPath(pdfUrl) {
  if (!pdfUrl || typeof pdfUrl !== 'string') {
    return pdfUrl;
  }

  const projectSegment = '/project/integrationmodulewithtab/';
  const segmentIndex = pdfUrl.toLowerCase().indexOf(projectSegment);
  if (segmentIndex >= 0) {
    return pdfUrl.slice(segmentIndex);
  }

  return pdfUrl.replace(/^https:\/\//, '');
}

/**
 * Replace a stale project id embedded in an integration-hub PDF link with the
 * project the user is currently viewing.
 */
export function normalizeIntegrationPdfUrl(pdfUrl, currentProjectId) {
  if (!pdfUrl || !currentProjectId) {
    return pdfUrl;
  }

  const path = stripIntegrationPdfUrlToPath(pdfUrl);
  const match = path.match(INTEGRATION_PDF_PATH);
  if (!match) {
    return path;
  }

  const pdfId = match[1];
  return `/project/integrationModuleWithTab/${currentProjectId}/pdf/${pdfId}`;
}
